(function () {
    'use strict';


    angular
        .module('app.campaign')
        .controller('SpecialEventsModalController', SpecialEventsModal);

    SpecialEventsModal.$inject = ['url', 'type', 'close'];
    function SpecialEventsModal(url, type, close) {
        var vm = this;
        vm.url = url;
        vm.type = type;

        vm.close = function () {
            close();
        }
    }

})();